import { render, staticRenderFns } from "./PersonalQuestionsCompleteModal.vue?vue&type=template&id=891f85b2&"
import script from "./PersonalQuestionsCompleteModal.vue?vue&type=script&lang=js&"
export * from "./PersonalQuestionsCompleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports